import { lazy } from "react";

export { SIGN_IN_PATH } from "./sign-in-path";
export const SignInPage = lazy(() => import("./sign-in"));
